import {
  INIT_VIDEO,
  SET_TOGGLE_VIDEO_PLAY_PAUSE,
  SET_VIDEO_VOLUME,
  SET_TOGGLE_VIDEO_MUTED,
  SET_VIDEO_PROGRESS,
  SET_VIDEO_DURATION,
  SET_VIDEO_SEEKING,
  SET_VIDEO_STOPPED,
  SET_VIDEO_MILESTONE,
  RESET_VIDEO_MILESTONE,
  SET_MEDIA_PLAY,
} from './types';

export const initVideo = ({ muted, volume, id }) => ({
  type: INIT_VIDEO,
  muted,
  volume,
  id,
});

export const setTogglePlayPause = ({ id }) => ({
  type: SET_TOGGLE_VIDEO_PLAY_PAUSE,
  id,
});

export const setVolume = ({ volume, id }) => ({
  type: SET_VIDEO_VOLUME,
  volume,
  id,
});

export const setToggleMuted = ({ id }) => ({
  type: SET_TOGGLE_VIDEO_MUTED,
  id,
});

export const setProgress = ({ progress, id }) => ({
  type: SET_VIDEO_PROGRESS,
  progress,
  id,
});

export const setDuration = ({ duration, id }) => ({
  type: SET_VIDEO_DURATION,
  duration,
  id,
});

export const setSeeking = ({ seeking, id }) => ({
  type: SET_VIDEO_SEEKING,
  seeking,
  id,
});

export const setStopped = ({ id }) => ({
  type: SET_VIDEO_STOPPED,
  id,
});

export const setMilestone = ({ percentage, id }) => ({
  type: SET_VIDEO_MILESTONE,
  percentage,
  id,
});

export const resetMilestone = ({ id }) => ({
  type: RESET_VIDEO_MILESTONE,
  id,
});

export const setMediaPlay = ({ id }) => ({
  type: SET_MEDIA_PLAY,
  id,
});

